import styled from 'styled-components';

export const SignUpContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 1em;
`;

export const SignUpTitle = styled.h2`
  margin: 10px 0;
`;
